module.exports = __webpack_public_path__ + "static/customFilter-f7dcd4a2013e8f2affc41946be8f174a.gif";